import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { Subject } from "rxjs/internal/Subject";
import { filter, combineLatest } from "rxjs";
if (typeof window !== "undefined") {
  window.BOSSJOB_SHARED_DATA = window.BOSSJOB_SHARED_DATA || {};
  window.BOSSJOB_INITIAL_PROPS = window.BOSSJOB_INITIAL_PROPS || {};
  window.BOSSJOB_BASE_SUBJECT = window.BOSSJOB_BASE_SUBJECT || new BehaviorSubject(null);
  window.BOSSJOB_NOTE_SUBJECT = window.BOSSJOB_NOTE_SUBJECT || new Subject(null);
}
const setCache = (id, data) => {
  var _a;
  const oldData = (_a = window.BOSSJOB_SHARED_DATA) == null ? void 0 : _a[id];
  const newData = typeof data === "function" ? data(oldData) : data;
  window.BOSSJOB_SHARED_DATA[id] = newData;
  if (!deepEqual(oldData, newData)) {
    window.BOSSJOB_BASE_SUBJECT.next({ type: "SHARE_DATA_CHANGED", id, data: window.BOSSJOB_SHARED_DATA[id] });
  }
};
const getSharedData = (id) => {
  return window.BOSSJOB_SHARED_DATA[id];
};
const getInitialProps = (id) => {
  return window.BOSSJOB_INITIAL_PROPS[id];
};
const setInitialProps = (id, data) => {
  window.BOSSJOB_INITIAL_PROPS[id] = data;
};
const postNotification = (id, note) => {
  window.BOSSJOB_NOTE_SUBJECT.next({ id, note });
};
const receiveNotification = (id, callback) => {
  const revoker = window.BOSSJOB_NOTE_SUBJECT.pipe(
    filter((data) => (data == null ? void 0 : data.id) === id)
  ).subscribe(callback);
  return () => revoker.unsubscribe();
};
const watchSharedData = (id, watcher) => {
  const revoker = window.BOSSJOB_BASE_SUBJECT.pipe(
    filter((note) => (note == null ? void 0 : note.type) === "SHARE_DATA_CHANGED"),
    filter(({ id: moduleId }) => moduleId === id)
  ).subscribe(watcher);
  return () => revoker.unsubscribe();
};
const publishSharedData = (id, data) => {
  setCache(id, data);
};
const waitClientData = async (keys) => {
  if (typeof window === "undefined") {
    return;
  }
  return new Promise((res) => {
    combineLatest(keys.map((key) => {
      return window.BOSSJOB_BASE_SUBJECT.pipe(
        filter((note) => (note == null ? void 0 : note.type) === "SHARE_DATA_CHANGED"),
        filter(({ id }) => key === id)
      );
    })).subscribe(
      (datas) => {
        if (datas.filter((data) => !data).length === 0) {
          res(datas);
        }
      }
    );
  });
};
const observerRender = (render, id) => {
  let rendered = false;
  let count = 0;
  const renderFunc = () => {
    const element = document.getElementById(id);
    if (element) {
      if (!rendered) {
        render();
        publishSharedData("MODULE_LOADED", (modules) => ({ ...modules, [id]: true }));
        rendered = true;
      }
    }
  };
  const start = () => {
    renderFunc();
    count++;
    if (!rendered && count < 100) {
      setTimeout(start, 200);
    }
  };
  start();
};
if (typeof window !== "undefined") {
  window.BOSSJOB_STORAGE_COMMANDS = {
    getSharedData,
    watchSharedData,
    getInitialProps,
    setInitialProps,
    publishSharedData
  };
}
function deepEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  }
  if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) {
    return false;
  }
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) {
      return false;
    }
    for (let i = 0; i < obj1.length; i++) {
      if (!deepEqual(obj1[i], obj2[i])) {
        return false;
      }
    }
    return true;
  }
  if (Object.prototype.toString.call(obj1) !== Object.prototype.toString.call(obj2)) {
    return false;
  }
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
}
export {
  getInitialProps,
  getSharedData,
  observerRender,
  postNotification,
  publishSharedData,
  receiveNotification,
  setInitialProps,
  waitClientData,
  watchSharedData
};
